import { Container, Flex } from '@grupoboticario/flora-react';
import { useLocation } from 'react-router-dom';
import slugify from 'slugify';

import {
  ErrorBoundaries,
  PageInfo,
  CardContentSkeleton,
  ResponsiveFloraTypography,
} from 'components';
import config from 'config';
import { pluralize } from 'helpers';
import { useResellerPlace } from 'hooks';

import { PlaceCard } from './components';
import Styles from './ResellerPlace.styles';

export const ResellerPlace = () => {
  const { data: places, isLoading, isError } = useResellerPlace();
  const { pathname } = useLocation();
  const pageTitle = `Espaço do ${config.communication.userNamingConvention.singular}`;

  if (isLoading) {
    return (
      <Container size='large'>
        <Styles.Grid>
          {[...Array(6)].map((_, index) => (
            <CardContentSkeleton key={`skeleton-${index}`} />
          ))}
        </Styles.Grid>
      </Container>
    );
  }

  if (isError) {
    return (
      <ErrorBoundaries.ReloadPage
        data-autotagging-flora-section={slugify(pageTitle)}
        title='Tivemos um problema para carregar seus Espaços'
      />
    );
  }

  return (
    <>
      <Container data-autotagging-flora-section={slugify(pageTitle, { lower: true })}>
        <PageInfo
          breadcrumbs={[
            {
              text: pageTitle,
              url: pathname,
            },
          ]}
        >
          <Flex direction='column' gap='$2'>
            <ResponsiveFloraTypography as='h1' fontSize='title' fontWeight='bold'>
              {pageTitle}
            </ResponsiveFloraTypography>

            <ResponsiveFloraTypography>
              Encontre Espaços próximos ao seu endereço cadastrado para comprar à pronta entrega.
            </ResponsiveFloraTypography>
          </Flex>
        </PageInfo>
      </Container>
      <Styles.Wrapper data-autotagging-flora-section={slugify(pageTitle, { lower: true })}>
        <Container size='large'>
          <Flex gap='$4' direction='column'>
            <ResponsiveFloraTypography as='h2' fontSize='subtitle' fontWeight='bold'>
              {pluralize(places?.length, 'Espaço disponível', 'Espaços disponíveis')}
            </ResponsiveFloraTypography>
            <ResponsiveFloraTypography fontSize='bodySmallShort' color='$nonInteractivePredominant'>
              {places?.length} {pluralize(places?.length, 'resultado', 'resultados')}
            </ResponsiveFloraTypography>
          </Flex>
          <Styles.Grid>
            {places.map((place, index) => (
              <PlaceCard {...place} key={`reseller-place-card-${index}`} />
            ))}
          </Styles.Grid>
        </Container>
      </Styles.Wrapper>
    </>
  );
};
